/** RFC 6266/5987: nome UTF-8 primeiro; nunca usa diretórios ou controles do cabeçalho. */
export function downloadFilename(header: string | null, fallback: string): string {
  const extended = header?.match(/(?:^|;)\s*filename\*\s*=\s*UTF-8'[^']*'([^;]+)/i)?.[1];
  const plain = header?.match(/(?:^|;)\s*filename\s*=\s*(?:"((?:[^"\\]|\\.)*)"|([^;]+))/i);
  let name = plain?.[1]?.replace(/\\(.)/g, '$1') ?? plain?.[2]?.trim() ?? fallback;
  if (extended) { try { name = decodeURIComponent(extended.trim().replace(/^"|"$/g, '')); } catch { /* Usa a reserva ASCII. */ } }
  return name.split(/[\\/]/).at(-1)?.replace(/[\u0000-\u001f\u007f]/g, '').trim() || fallback;
}
